import Box from '@mui/material/Box';

import { DashboardMenuItemMobile } from '../DashboardMenuItem';
import { GenericMenuItemsMobile } from '../GenericMenuItems';
import { MarketMenuItemMobile } from '../MarketMenuItem';
import { TradingMenuItemMobile } from '../TradingMenuItem';
import { WalletMenuItemMobile } from '../WalletMenuItem';
import { ToolbarMobileStyled } from './Menu.mobile.styles';

export const MenuMobile = () => {
  return (
    <Box>
      <ToolbarMobileStyled>
        <DashboardMenuItemMobile />
        <MarketMenuItemMobile />
        <WalletMenuItemMobile />
        <TradingMenuItemMobile />
        <GenericMenuItemsMobile />
      </ToolbarMobileStyled>
    </Box>
  );
};
